// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NastupnoPredavanje_raniRazvojHeader__391Do {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.028px;
}
.NastupnoPredavanje_wrapper__JWHN7 {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  width: 100%;
}
.NastupnoPredavanje_raniRazvojDescription__Ew1a2 {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.014px;
}
.NastupnoPredavanje_predavanjaWrapper__OzoYx {
  width: 100%;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #d1d9e2;
  border-radius: 10px;
  padding: 16px 0px 16px 0px;
}
.NastupnoPredavanje_predavanjaWrapper__OzoYx,
.NastupnoPredavanje_addPredavanjeBtn__sJG3z,
.NastupnoPredavanje_predavanjaRow__YUCS3 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}
.NastupnoPredavanje_predavanjaRow__YUCS3 {
  width: 100%;
  padding: 0px 16px;
  gap: 16px;
}
.NastupnoPredavanje_label__OxHx3,
.NastupnoPredavanje_addPredavanjeBtn__sJG3z,
.NastupnoPredavanje_predavanjaLabel__lP2O3 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.NastupnoPredavanje_label__OxHx3,
.NastupnoPredavanje_addPredavanjeBtn__sJG3z {
  text-align: left;
  color: #5f6d7e;
}
.NastupnoPredavanje_addPredavanjeBtn__sJG3z {
  gap: 16px;
  width: 30%;
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  height: 50px;
}
.NastupnoPredavanje_addPredavanjeBtn__sJG3z:hover {
  cursor: pointer;
  background-color: #d1d9e2;
}
.NastupnoPredavanje_success__nWPg6 {
  width: 24px;
  height: 24px;
}
.NastupnoPredavanje_predavanjaLabel__lP2O3 {
  text-align: center;
  color: #9fa7b2;
}

@media screen and (max-width: 1150px) {
  .NastupnoPredavanje_addPredavanjeBtn__sJG3z {
    width: fit-content;
    padding: 0 20px;
  }
}

@media screen and (max-width: 420px) {
  .NastupnoPredavanje_addPredavanjeBtn__sJG3z {
    font-size: 15px;
    padding: 0 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/NastupnoPredavanje/NastupnoPredavanje.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".raniRazvojHeader {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.028px;\n}\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  width: 100%;\n}\n.raniRazvojDescription {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.014px;\n}\n.predavanjaWrapper {\n  width: 100%;\n  flex-direction: column;\n  gap: 16px;\n  border: 1px solid #d1d9e2;\n  border-radius: 10px;\n  padding: 16px 0px 16px 0px;\n}\n.predavanjaWrapper,\n.addPredavanjeBtn,\n.predavanjaRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n}\n.predavanjaRow {\n  width: 100%;\n  padding: 0px 16px;\n  gap: 16px;\n}\n.label,\n.addPredavanjeBtn,\n.predavanjaLabel {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.label,\n.addPredavanjeBtn {\n  text-align: left;\n  color: #5f6d7e;\n}\n.addPredavanjeBtn {\n  gap: 16px;\n  width: 30%;\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  height: 50px;\n}\n.addPredavanjeBtn:hover {\n  cursor: pointer;\n  background-color: #d1d9e2;\n}\n.success {\n  width: 24px;\n  height: 24px;\n}\n.predavanjaLabel {\n  text-align: center;\n  color: #9fa7b2;\n}\n\n@media screen and (max-width: 1150px) {\n  .addPredavanjeBtn {\n    width: fit-content;\n    padding: 0 20px;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .addPredavanjeBtn {\n    font-size: 15px;\n    padding: 0 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"raniRazvojHeader": `NastupnoPredavanje_raniRazvojHeader__391Do`,
	"wrapper": `NastupnoPredavanje_wrapper__JWHN7`,
	"raniRazvojDescription": `NastupnoPredavanje_raniRazvojDescription__Ew1a2`,
	"predavanjaWrapper": `NastupnoPredavanje_predavanjaWrapper__OzoYx`,
	"addPredavanjeBtn": `NastupnoPredavanje_addPredavanjeBtn__sJG3z`,
	"predavanjaRow": `NastupnoPredavanje_predavanjaRow__YUCS3`,
	"label": `NastupnoPredavanje_label__OxHx3`,
	"predavanjaLabel": `NastupnoPredavanje_predavanjaLabel__lP2O3`,
	"success": `NastupnoPredavanje_success__nWPg6`
};
export default ___CSS_LOADER_EXPORT___;
